import { FullscreenControl, NavigationControl } from "@vis.gl/react-maplibre";
import { FC } from "react";

interface IMapLibreControlsProps {
  /** Element id to fullscreen — the outer host, so overlays outside the map div stay visible. */
  containerId?: string;
  /**
   * Off by default: on Leaflet only the ride route block and the investigation map mounted a fullscreen
   * control, and the grid maps, polygon editors and small previews shipped with zoom alone. Screens that
   * want one now opt in — the passenger form does, which is a deliberate addition rather than a port.
   */
  isFullscreenEnabled?: boolean;
}

export const MapLibreControls: FC<IMapLibreControlsProps> = ({
  containerId,
  isFullscreenEnabled,
}) => (
  <>
    {isFullscreenEnabled && (
      <FullscreenControl position="top-left" containerId={containerId} />
    )}
    <NavigationControl position="top-left" showCompass={false} />
  </>
);
